export const checkUrl = (url: string) => {
  let x: URL | string = '';
  try {
    x = new URL(url);
  } catch (_) {
    return false;
  }
  if (x) {
    return true;
  }
  return false;
};
